<template>
  <component-wrapper>
    <div class="teaser-big-image-fi">
      <teaser-big-image-element-fi :fields="fields" />
    </div>
  </component-wrapper>
</template>

<script setup lang="ts">
import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import TeaserBigImageElementFi from '@/components/teaser/teaser-big-image-element-fi/TeaserBigImageElementFi.vue';
import type { TeaserBigImageInnovationFiFields } from '@/generated/fields';

defineOptions({ name: 'TeaserBigImageInnovationFi' });

withDefaults(
  defineProps<{
    fields?: TeaserBigImageInnovationFiFields;
  }>(),
  {
    fields: () => ({}) as TeaserBigImageInnovationFiFields,
  },
);
</script>
